import { isHotelProperty } from '@merchant-backend/util'
import { isSiDaMember, isSiDaTeam } from '@util'
import React, { Component } from 'react'

class ImgChange extends Component {
  constructor(props) {
    super(props)
    this.state = {
      index: 0
    }
  }
  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({
        index: (this.state.index + 1) % this.getImages().length
      })
    }, 1000)
  }
  componentWillUnmount() {
    clearInterval(this.timer)
  }

  getImages = () => {
    if (isSiDaMember()) {
      return [
        'https://qnm.hunliji.com/o_1dn6iojpfarb1arq1st1l3n16n3b.png',
        'https://qnm.hunliji.com/o_1dn6iojpf3c1gjd158nv06nvrc.png',
        'https://qnm.hunliji.com/o_1dn6iojpf11lv1jdm12d6el35dbd.png'
      ]
    }

    if (isSiDaTeam()) {
      return [
        'https://qnm.hunliji.com/o_1dnubfh9hi10ecg1g061rosiosn.png',
        'https://qnm.hunliji.com/o_1dnubfh9h1un51n11i1avc1c9hm.png',
        'https://qnm.hunliji.com/o_1dnubgc1k8kih8m1oda134i1toa12.png'
      ]
    }

    if (isHotelProperty()) {
      if (this.props.forPro) {
        return ['//qnm.hunliji.com/FpbLEBT1HS-AdgYewmzoomp9rcaT']
      } else {
        return ['//qnm.hunliji.com/o_1dpkd7fr41svsstk1ibo17h31kbvj.png']
      }
    }

    return [
      'https://qnm.hunliji.com/o_1d4nesjvn13it1f7l15if30su08d.png',
      'https://qnm.hunliji.com/o_1d4nesjvnhajpbm3lasks117re.png',
      'https://qnm.hunliji.com/o_1d4nesjvn1hgqbum118mqie1ogsf.png',
      'https://qnm.hunliji.com/o_1d4nesjvo1qpe1l5i1c4tdk018ong.png',
      'https://qnm.hunliji.com/o_1d4nesjvopc7t5m1d6p1nvm1c3dh.png'
    ]
  }

  render() {
    const { index } = this.state

    return (
      <div className="img-z-index-wrap">
        {this.getImages().map((item, i) => {
          return (
            <img
              key={i}
              style={{ zIndex: index === i ? '5' : '1' }}
              className={`img-z-index ${
                this.props.forPro && isHotelProperty() ? 'forPro' : ''
              }`}
              src={item}
            />
          )
        })}
      </div>
    )
  }
}

export default ImgChange
